import { render, staticRenderFns } from "./CustomerSearchMenu.vue?vue&type=template&id=4b804469"
import script from "./CustomerSearchMenu.vue?vue&type=script&lang=js"
export * from "./CustomerSearchMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports